import React, { useContext } from "react";
import PropTypes from "prop-types";
import InvoicingContext from "./InvoicingContext";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import { useDispatch, useSelector } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";

function DetailTable({ data, resources, onRowClick, onRowsDeleted, isUserCreating }) {
    const { products } = resources;
    const { user } = useSelector((state) => state.Login);
    const dispatch = useDispatch();
    const { InvoiceDetails } = useContext(InvoicingContext);
    const getProduct = (id) => products.find((x) => x.id === id);

    const headCells = [
        {
            index: 1,
            id: "productId",
            disablePadding: false,
            label: "Service",
            render: (_, { value }) => getProduct(value)?.name,
        },
        { index: 2, id: "unitPrice", disablePadding: false, label: "U. Price", type: "currency", numeric: true },
        { index: 3, id: "quantity", disablePadding: false, label: "Quantity", numeric: true },
        { index: 4, id: "totalPrice", disablePadding: false, label: "Total", type: "currency", numeric: true },
    ];

    function onDeleteSuccess(deletedItems) {
        dispatch(notifyInfo("Removed successfully!"));
        onRowsDeleted(deletedItems);
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        InvoiceDetails.deleteAll({
            ids: selectedItems,
            onSuccess: () => onDeleteSuccess(selectedItems),
            onError: onDeleteError,
        });
    }

    return (
        <div className="layout">
            <EnhancedTable
                title="Services"
                headCells={headCells}
                data={data}
                onRowClick={onRowClick}
                keyColumnName="id"
                selectable={user.isAdmin || isUserCreating}
                deletable={user.isAdmin || isUserCreating}
                onDelete={(user.isAdmin || isUserCreating) && onDeleteHandler}
                filterable={false}
                pageable={false}
                orderable={false}
            />
        </div>
    );
}

DetailTable.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            amount: PropTypes.number,
            categoryId: PropTypes.number,
            paymentMethod: PropTypes.string,
        })
    ),
    resources: PropTypes.shape({
        categories: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                code: PropTypes.string,
                name: PropTypes.string,
            })
        ),
    }),
    onRowClick: PropTypes.func,
    isUserCreating: PropTypes.bool,
};

DetailTable.defaultProps = {
    data: [],
    resources: {
        categories: [],
    },
    onRowClick: (item) => true,
    isUserCreating: false,
};

export default DetailTable;
